var authorization = 'Bearer kxDrQOZfZyIJ28LrRRj3rHc3JUPbkW2NSucWbf5V';

var season_t = [ "Saison","Season","Saison" ];
var support_by_t = [ "wird unterstützt von","is supported by","est soutenu par" ];
var at_fcz_t = [ "BEIM FCZ SEIT","AT FCZ SINCE","AU FCZ DEPUIS" ];
var big_success_t = [ "GRÖSSTER ERFOLG","BIGGEST SUCCESS","PLUS GRAND SUCCÈS" ];
var former_clubs_t = [ "FRÜHERE VEREINE","FORMER CLUBS","ANCIENS CLUBS" ];
var matches_t = [ "MATCHES","MATCHES","MATCHES" ];
var minutes_played_t = [ "SPIELMINUTEN","MINUTES PLAYED","MINUTES DE JEU" ];
var goals_t = [ "TORE","GOALS","BUTS" ];
var assists_t = [ "TORVORLAGEN","ASSISTS","PASSES DÉCISIVES" ];
var substitutions_t = [ "AUSWECHSLUNGEN","SUBSTITUTIONS","REMPLACEMENTS" ];
var red_card_t = [ "ROTE KARTEN","RED CARDS","CARTES ROUGES" ];
var yellow_red_card_t = [ "GELB-ROTE KARTEN","YELLOW-RED CARDS","CARTES JAUNES ET ROUGES" ];
var yellow_card_t = [ "GELBE KARTEN","YELLOW CARD","CARTES JAUNES" ];

var url = window.location.href,
    parts = url.split("/"),
    last_part = parts[parts.length-1].replace('%20','');

if(window.location.href.indexOf("?season") > -1) {
  parts = url.split("?"),
  newUrl = parts[parts.length-2],
  newparts = newUrl.split("/"),
  last_part = newparts[newparts.length-1].replace('%20','');
  var season = getParameterByName('season');
}else{
  var season = '2022/2023';
}
var player= '',
    playerID = '';


var fcz_hattrick = '',
	nationality = '',
	jerseyNo = '',
	position = '',
	Beim_FCZ_seit = '',
    biggest_success = '',
    former_clubs = '';

    var playerurl = window.location.href,
    playerHandle = playerurl.split('pages/');    
    if(playerHandle.length > 1){
      player = '?filter[profileUrl]='+playerHandle[1];
      if(playerurl.indexOf("?season") > -1) {
        player = player.replace('?season','&season');
      }
    }
    
//console.log("player",player);

if(player != ''){
var settings = {
  "url": "https://app.aico.swiss/19838/api/v1/b2cs"+player,
  "method": "GET",
  "timeout": 0,
  "headers": {
    "Authorization": authorization,
    "Accept": "application/vnd.api+json",
  },
};

$.ajax(settings).fail(function(jqXHR) {
  var msg = '';
  var html ='';
  if (jqXHR.status === 0) {
      msg = 'Not connect.\n Verify Network.';
  }else if(jqXHR.status !== 0){
    msg = jqXHR.status
  } else {
      msg = 'Uncaught Error.\n' + jqXHR.responseText;
  }
    
      
    html = `
    <div class="error-container">
	<h1 class="header">${msg} ERROR</h1>
	<div class="instructions">
		<h2>Entschuldigung! Etwas lief schief bei uns. Wir versuchen derzeit, das Problem zu beheben.</h2>
		<p>In der Zwischenzeit können Sie:</p>
		<div class="step">
			<svg class="icon" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 489.711 489.711">
				<path d="M112.156,97.111c72.3-65.4,180.5-66.4,253.8-6.7l-58.1,2.2c-7.5,0.3-13.3,6.5-13,14c0.3,7.3,6.3,13,13.5,13    c0.2,0,0.3,0,0.5,0l89.2-3.3c7.3-0.3,13-6.2,13-13.5v-1c0-0.2,0-0.3,0-0.5v-0.1l0,0l-3.3-88.2c-0.3-7.5-6.6-13.3-14-13    c-7.5,0.3-13.3,6.5-13,14l2.1,55.3c-36.3-29.7-81-46.9-128.8-49.3c-59.2-3-116.1,17.3-160,57.1c-60.4,54.7-86,137.9-66.8,217.1    c1.5,6.2,7,10.3,13.1,10.3c1.1,0,2.1-0.1,3.2-0.4c7.2-1.8,11.7-9.1,9.9-16.3C36.656,218.211,59.056,145.111,112.156,97.111z"></path>
					<path d="M462.456,195.511c-1.8-7.2-9.1-11.7-16.3-9.9c-7.2,1.8-11.7,9.1-9.9,16.3c16.9,69.6-5.6,142.7-58.7,190.7    c-37.3,33.7-84.1,50.3-130.7,50.3c-44.5,0-88.9-15.1-124.7-44.9l58.8-5.3c7.4-0.7,12.9-7.2,12.2-14.7s-7.2-12.9-14.7-12.2l-88.9,8    c-7.4,0.7-12.9,7.2-12.2,14.7l8,88.9c0.6,7,6.5,12.3,13.4,12.3c0.4,0,0.8,0,1.2-0.1c7.4-0.7,12.9-7.2,12.2-14.7l-4.8-54.1    c36.3,29.4,80.8,46.5,128.3,48.9c3.8,0.2,7.6,0.3,11.3,0.3c55.1,0,107.5-20.2,148.7-57.4    C456.056,357.911,481.656,274.811,462.456,195.511z"></path>
			</svg>
			<p>Lade die Seite neu</p>
		</div>
		<div class="step">
			<svg class="icon" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 60 60">
				<path d="M30,0C13.458,0,0,13.458,0,30s13.458,30,30,30s30-13.458,30-30S46.542,0,30,0z M30,58C14.561,58,2,45.439,2,30   S14.561,2,30,2s28,12.561,28,28S45.439,58,30,58z"></path>
				<path d="M30,6c-0.552,0-1,0.447-1,1v23H14c-0.552,0-1,0.447-1,1s0.448,1,1,1h16c0.552,0,1-0.447,1-1V7C31,6.447,30.552,6,30,6z"></path>
			</svg>
			<p>Warte ein paar Minuten</p>
	</div>
	</ul>
</div>
</div>
    `;
  

  
  $('.player-professional-details #player-professional-details').html(html);
  $('.player-news').hide();
  $('.section-collection-list').hide();
  $('#status').fadeOut();
  $('#preloader').fadeOut('slow');
  
})
.done(function (response) {
  //console.log(response);
  
  var data = response.data[0].attributes;
  var PlayerID = response.data[0].id;

  var html = '',
      playerHtml = '';
  
  $('title').text(data.firstName+' '+data.lastName+' - FC Zürich');

  if(data.formOfAddress == 'Mrs.'){
    $('.section-frauen-partners').removeClass('hidden');
    $('.section-partners').addClass('hidden');
  }
  
  for(var c=0; c<data.customFields.length; c++){
    
    if(data.customFields[c].locale == 'de_CH'){
      
      if(data.customFields[c].name == 'Zweite Nationalität'){
        nationality = data.customFields[c].value;
      }
      if(data.customFields[c].name == 'Trikotnummer'){
        jerseyNo = data.customFields[c].value;
      }
      
      /*if(data.customFields[c].name == 'Position'){
        position = data.customFields[c].value;
      }*/
      
      if((data.customFields[c].name).trim() == 'Beim FCZ seit'){
        Beim_FCZ_seit = data.customFields[c].value;
      }
      if(data.customFields[c].name == 'Grösster Erfolg'){
        biggest_success = data.customFields[c].value;
      }
      if(data.customFields[c].name == 'Frühere Vereine'){
        former_clubs = data.customFields[c].value;
      }
      
    }

  }
  
  
  html += '<div class="player-personal-detail">';
  if(jerseyNo != null && jerseyNo != ""){
    html += '<div class="player-joursey">'+jerseyNo+'</div>';
  }
    html += '<div class="player-name player-'+jerseyNo+'">';
      html += '<h2>'+data.firstName+' '+data.lastName+'</h2>';
  	if(data.position != null && data.position != ""){
  	  html += '<div class="player-position">'+data.position+'</div>';
  	}
    html += '</div>';
  html += '</div>';
  
  
  html += '<div class="player-micro-detail">';
  if(data.birthDate != null && data.birthDate != ""){
        html += '<div class="pl-d-birth">';
            html += '<span><svg xmlns="http://www.w3.org/2000/svg" width="19.293" height="21.437" viewBox="0 0 19.293 21.437">';
                html += '<path id="Icon_material-date-range" data-name="Icon material-date-range" d="M10.931,12.647H8.787V14.79h2.144Zm4.287,0H13.075V14.79h2.144Zm4.287,0H17.362V14.79h2.144Zm2.144-7.5H20.578V3H18.434V5.144H9.859V3H7.716V5.144H6.644A2.134,2.134,0,0,0,4.511,7.287L4.5,22.293a2.143,2.143,0,0,0,2.144,2.144H21.649a2.15,2.15,0,0,0,2.144-2.144V7.287A2.15,2.15,0,0,0,21.649,5.144Zm0,17.149H6.644V10.5H21.649Z" transform="translate(-4.5 -3)" fill="#ae9357"/>';
            html += '</svg></span>';
            html += regularDate(data.birthDate);
        html += '</div>';
  }
  if(data.birthplace != null && data.birthplace != ""){
        html += '<div class="pl-birth-place">';
            html += '<span><svg xmlns="http://www.w3.org/2000/svg" width="13.344" height="21.35" viewBox="0 0 13.344 21.35">';
                html += '<path id="Icon_metro-location" data-name="Icon metro-location" d="M15.027,1.928A6.672,6.672,0,0,0,8.355,8.6c0,6.672,6.672,14.678,6.672,14.678S21.7,15.272,21.7,8.6a6.672,6.672,0,0,0-6.672-6.672Zm0,10.759A4.087,4.087,0,1,1,19.113,8.6,4.087,4.087,0,0,1,15.027,12.687ZM12.441,8.6a2.585,2.585,0,1,1,2.585,2.585A2.585,2.585,0,0,1,12.441,8.6Z" transform="translate(-8.355 -1.928)" fill="#ae9357"/>';
            html += '</svg></span>';
            html += data.birthplace;
        html += '</div>';
  }
  if(data.nationality != null && data.nationality != ""){
        html += '<div class="pl-nationality">';
            html += '<span><svg xmlns="http://www.w3.org/2000/svg" width="18.865" height="21.56" viewBox="0 0 18.865 21.56">';
                html += '<path id="Icon_awesome-passport" data-name="Icon awesome-passport" d="M5.458,7.411H7.1a9.5,9.5,0,0,1,.6-2.965A4.036,4.036,0,0,0,5.458,7.411Zm0,1.347A4.037,4.037,0,0,0,7.7,11.724a9.49,9.49,0,0,1-.6-2.965H5.458Zm3.974,3.314a5.729,5.729,0,0,0,.987-3.314H8.445a5.732,5.732,0,0,0,.987,3.314ZM8.446,7.411h1.974A5.73,5.73,0,0,0,9.433,4.1,5.726,5.726,0,0,0,8.446,7.411Zm2.716,4.312a4.036,4.036,0,0,0,2.244-2.965H11.761A9.49,9.49,0,0,1,11.162,11.724ZM17.517,0H2.695A2.7,2.7,0,0,0,0,2.695v16.17A2.7,2.7,0,0,0,2.695,21.56H17.517a1.348,1.348,0,0,0,1.347-1.347V1.347A1.348,1.348,0,0,0,17.517,0ZM14.149,17.517H4.716a.674.674,0,0,1,0-1.347h9.432a.674.674,0,0,1,0,1.347ZM9.432,13.475a5.39,5.39,0,1,1,5.39-5.39A5.39,5.39,0,0,1,9.432,13.475Zm1.73-9.029a9.49,9.49,0,0,1,.6,2.965h1.646a4.036,4.036,0,0,0-2.244-2.965Z" fill="#ae9357"/>';
            html += '</svg></span>';
            html += data.nationality
            if(nationality != null){
            	html += '/'+nationality;
            }
        html += '</div>';
  }
  if(data.height != null && data.height != ""){
        html += '<div class="pl-height">';
            html += '<span><svg xmlns="http://www.w3.org/2000/svg" width="13.334" height="21.335" viewBox="0 0 13.334 21.335">';
                html += '<path id="Icon_open-resize-height" data-name="Icon open-resize-height" d="M6.667,0,0,8H5.334v5.334H0l6.667,8,6.667-8H8V8h5.334Z" fill="#ae9357"/>';
            html += '</svg></span>';
            html += data.height+' cm';
        html += '</div>';
  }
  if(data.weight != null && data.weight != ""){
        html += '<div class="pl-weight">';
            html += '<span><svg xmlns="http://www.w3.org/2000/svg" width="20.599" height="20.599" viewBox="0 0 20.599 20.599">';
                html += '<path id="Icon_awesome-weight-hanging" data-name="Icon awesome-weight-hanging" d="M20.53,17.939,17.592,6.185A1.311,1.311,0,0,0,16.35,5.151H13.926a3.863,3.863,0,1,0-7.252,0H4.25A1.311,1.311,0,0,0,3.008,6.185L.069,17.939A2.075,2.075,0,0,0,1.932,20.6H18.668A2.075,2.075,0,0,0,20.53,17.939ZM10.3,5.15a1.287,1.287,0,1,1,1.287-1.287A1.289,1.289,0,0,1,10.3,5.15Z" transform="translate(0 -0.001)" fill="#ae9357"/>';
            html += '</svg></span>';
            html += data.weight+' kg';
        html += '</div>';
  }
  if(data.hobbies != null && data.hobbies != ""){
        html += '<div class="pl-hobby">';
            html += '<span><svg xmlns="http://www.w3.org/2000/svg" width="21.493" height="10.557" viewBox="0 0 21.493 10.557">';
                html += '<path id="Icon_ionic-logo-game-controller-a" data-name="Icon ionic-logo-game-controller-a" d="M18.436,10.266H7.562a5.175,5.175,0,0,0-5.312,5.25,5.22,5.22,0,0,0,5.312,5.307H18.431a5.22,5.22,0,0,0,5.312-5.307A5.169,5.169,0,0,0,18.436,10.266Zm-8.124,5.792a.262.262,0,0,1-.25.254H8.392V18a.272.272,0,0,1-.278.235H7.087a.221.221,0,0,1-.23-.216v-1.7H5.172a.272.272,0,0,1-.235-.278V15.007a.221.221,0,0,1,.216-.23h1.7v-1.67a.234.234,0,0,1,.221-.25h1.06a.262.262,0,0,1,.254.25v1.67h1.67a.234.234,0,0,1,.25.221Zm5.749.422A.921.921,0,1,1,17,15.558.931.931,0,0,1,16.06,16.48ZM18.1,18.486a.919.919,0,1,1,.936-.917A.927.927,0,0,1,18.1,18.486Zm0-4.016a.919.919,0,1,1,.936-.917A.93.93,0,0,1,18.1,14.469Zm2.044,2.011a.921.921,0,1,1,.936-.921A.927.927,0,0,1,20.144,16.48Z" transform="translate(-2.25 -10.266)" fill="#ae9357"/>';
            html += '</svg></span>';
            html += data.hobbies;
        html += '</div>';
  }
    html += '</div>';
  
  
  var fb = data.facebook,
  	  insta = data.instagram,
  	  linkedin = data.linkedin,
      twitter = data.twitter;
  
  var socialicon = '';
  // if(fb == null && insta == null && linkedin == null && twitter == null && data.filenameDocument1 == null && data.filenameDocument2 == null ){
  //   var socialicon = 'empty_social';
  // }
    
  html += '<div class="player-social-con '+socialicon+'">';
        html += '<ul class="social-list">';
  		if(fb!=null && fb != ""){
    		let url = fb,
          		parts = url.split("/"),
          		social_handle = parts[parts.length-1];

          if(social_handle == ''){
              social_handle = parts[parts.length-2];
          }
            html += '<li>';
                html += '<a href="'+ fb +'" target="_blank" class="fb">';
                    html += '<svg xmlns="http://www.w3.org/2000/svg" width="26" height="26" viewBox="0 0 26 26">';
                        html += '<path id="Icon_awesome-facebook-square" data-name="Icon awesome-facebook-square" d="M23.214,2.25H2.786A2.786,2.786,0,0,0,0,5.036V25.464A2.786,2.786,0,0,0,2.786,28.25h7.965V19.411H7.095V15.25h3.656V12.079c0-3.607,2.147-5.6,5.436-5.6a22.15,22.15,0,0,1,3.222.281V10.3H17.595a2.08,2.08,0,0,0-2.346,2.248v2.7h3.992L18.6,19.411H15.249V28.25h7.965A2.786,2.786,0,0,0,26,25.464V5.036A2.786,2.786,0,0,0,23.214,2.25Z" transform="translate(0 -2.25)" fill="#ae9357"/>';
                    html += '</svg>';
                html += '</a>';
            html += '</li>';
        }        
  		if(insta!=null && insta != ""){
          let url = insta,
              parts = url.split("/"),
              social_handle = parts[parts.length-1];

          if(social_handle == ''){
              social_handle = parts[parts.length-2];
          }
            html += '<li>';
                html += '<a href="'+ insta +'" target="_blank" class="insta">';
                    html += '<svg xmlns="http://www.w3.org/2000/svg" width="26" height="26" viewBox="0 0 37.134 37.134">';
                        html += '<g id="Group_1141" data-name="Group 1141" transform="translate(-481 -1717.596)">';
                        html += '<path id="Path_12090" data-name="Path 12090" d="M11.891,1.75H28.743A10.153,10.153,0,0,1,38.884,11.891V28.743A10.153,10.153,0,0,1,28.743,38.884H11.891A10.153,10.153,0,0,1,1.75,28.743V11.891A10.153,10.153,0,0,1,11.891,1.75Zm16.852,33.7a6.719,6.719,0,0,0,6.711-6.711V11.891A6.719,6.719,0,0,0,28.743,5.18H11.891A6.719,6.719,0,0,0,5.18,11.891V28.743a6.719,6.719,0,0,0,6.711,6.711Z" transform="translate(479.25 1715.846)" fill="#ae9357"/>';
                        html += '<path id="Path_12091" data-name="Path 12091" d="M19.269,10.685a8.5,8.5,0,0,1,1.243.092,8.456,8.456,0,0,1,2.561,15.917,8.494,8.494,0,0,1-3.8.9,8.456,8.456,0,0,1,0-16.912Zm0,13.482a5.026,5.026,0,1,0-3.556-1.472A5,5,0,0,0,19.274,24.167Z" transform="translate(480.368 1716.949)" fill="#ae9357"/>';
                        html += '<path id="Path_12092" data-name="Path 12092" d="M26.25,9.75h0" transform="translate(482.586 1717.145)" fill="none" stroke="#ae9357" stroke-linecap="round" stroke-linejoin="round" stroke-width="2.5"/>';
                        html += '</g>';
                    html += '</svg>';
                html += '</a>';
            html += '</li>';
        }        
        if(linkedin!=null && linkedin != ""){
          let url = linkedin,
          parts = url.split("/"),
          social_handle = parts[parts.length-1];

          if(social_handle == ''){
              social_handle = parts[parts.length-2];
          }
            html += '<li>';
                html += '<a href="'+linkedin+'" target="_blank" class="linkedin">';
                    html += '<svg xmlns="http://www.w3.org/2000/svg" width="24.921" height="24.921" viewBox="0 0 24.921 24.921">';
                        html += '<path id="Icon_awesome-linkedin" data-name="Icon awesome-linkedin" d="M23.141,2.25H1.775A1.788,1.788,0,0,0,0,4.047V25.375a1.788,1.788,0,0,0,1.775,1.8H23.141a1.793,1.793,0,0,0,1.78-1.8V4.047A1.793,1.793,0,0,0,23.141,2.25ZM7.532,23.611H3.838V11.718h3.7V23.611ZM5.685,10.094A2.142,2.142,0,1,1,7.827,7.952,2.143,2.143,0,0,1,5.685,10.094ZM21.378,23.611H17.684V17.826c0-1.38-.028-3.154-1.919-3.154-1.925,0-2.22,1.5-2.22,3.054v5.885H9.852V11.718H13.4v1.624h.05a3.89,3.89,0,0,1,3.5-1.919c3.738,0,4.434,2.464,4.434,5.669Z" transform="translate(0 -2.25)" fill="#ae9357"/>';
                    html += '</svg>';
                html += '</a>';
            html += '</li>';
        }
        if(twitter!=null && twitter != ""){
          let url = twitter,
          parts = url.split("/"),
          social_handle = parts[parts.length-1];

          if(social_handle == ''){
              social_handle = parts[parts.length-2];
          }
            html += '<li>';
                html += '<a href="'+twitter+'" target="_blank" class="twitter">';
                    html += '<svg xmlns="http://www.w3.org/2000/svg" width="26" height="26" viewBox="0 0 26 26">';
                        html += '<path id="Icon_awesome-twitter-square" data-name="Icon awesome-twitter-square" d="M23.214,2.25H2.786A2.786,2.786,0,0,0,0,5.036V25.464A2.786,2.786,0,0,0,2.786,28.25H23.214A2.786,2.786,0,0,0,26,25.464V5.036A2.786,2.786,0,0,0,23.214,2.25Zm-2.838,9.216c.012.162.012.331.012.493A10.756,10.756,0,0,1,9.558,22.789a10.78,10.78,0,0,1-5.844-1.706,8.019,8.019,0,0,0,.917.046A7.631,7.631,0,0,0,9.355,19.5,3.811,3.811,0,0,1,5.8,16.863a4.1,4.1,0,0,0,1.718-.07,3.807,3.807,0,0,1-3.047-3.737V13.01a3.8,3.8,0,0,0,1.718.482,3.8,3.8,0,0,1-1.695-3.169A3.759,3.759,0,0,1,5.008,8.4a10.808,10.808,0,0,0,7.846,3.981,3.814,3.814,0,0,1,6.494-3.476,7.459,7.459,0,0,0,2.414-.917,3.8,3.8,0,0,1-1.671,2.1,7.575,7.575,0,0,0,2.194-.592A8.012,8.012,0,0,1,20.376,11.466Z" transform="translate(0 -2.25)" fill="#ae9357"/>';
                    html += '</svg>';
                html += '</a>';
            html += '</li>';
        }
        html += '</ul>';
  
        html += '<div class="fcz-hattrick-wrapper">';
        if(data.customerDocuments.length>0){
            for(var cd=0; cd<data.customerDocuments.length; cd++){   
              if(data.customerDocuments[cd].document != null && data.customerDocuments[cd].documentName != null && data.customerDocuments[cd].document != '' && data.customerDocuments[cd].documentName != '' ){               
                if(data.customerDocuments[cd].documentNumber == '1'){
                  html += '<a href="'+data.customerDocuments[cd].document+'" class="button button--primary" target="_blank" rel="noopener noreferrer">FCZ-HATTRICK</a>';
                }
                if(data.customerDocuments[cd].documentNumber == '2'){
                  html += '<a href="'+data.customerDocuments[cd].document+'" class="button button--primary" target="_blank" rel="noopener noreferrer">DIE 13</a>';
                }
              
              }
            }
         }
  
          // if(data.filenameDocument1 != null && data.filenameDocument1 != ''){
          //   html += '<a href="'+data.document1+'" class="button button--primary" target="_blank" rel="noopener noreferrer">FCZ-HATTRICK</a>';
          // }
          // if(data.filenameDocument2 != null && data.filenameDocument2 != ''){
          //   html += '<a href="'+data.document2+'" class="button button--primary" target="_blank" rel="noopener noreferrer">DIE 13</a>';
          // }
        html += '</div>';
  
    html += '</div>';

  // if(){
    if(data.sponsors.length > 0 && data.isActive == 1){
      
      html += '<div class="player-sponsored-banner">';
          html += '<div class="sponsored-banner-title">';
              html += data.firstName+' '+data.lastName+' '+support_by_t[lang]+':';
          html += '</div>';
        html += '<div class="sponsors-block">';
        for(var s = 0; s<data.sponsors.length; s++){
          html += '<div class="sponsored-banner-img">';
              if(data.sponsors[s].website != null && data.sponsors[s].website != ""){
              html += '<a href="'+data.sponsors[s].website+'" target="_blank">';
              }
              if(data.sponsors[s].image != null && data.sponsors[s].image != ""){           
                html += '<img srcset="'+data.sponsors[s].image+'" loading="lazy">'; 
              } else if(data.sponsors[s].profilePhotoUrl != null && data.sponsors[s].profilePhotoUrl != ""){
                html += '<img srcset="'+data.sponsors[s].profilePhotoUrl+'" loading="lazy">';    
              }         
              if(data.sponsors[s].website != null && data.sponsors[s].website != ""){
              html += '</a>';
              }
          html += '</div>';
        }
        html += '</div>';
      html += '</div>';
    }
  // }
  
  
  playerHtml += '<div class="image-wrapper">';
    if(data.coverPhoto != null && data.coverPhoto != ""){
      var img = data.coverPhoto
    }
    else if(data.image != null && data.image != ""){
      var img = data.image;
    }
    else {
      var img = 'https://cdn.shopify.com/s/files/1/0565/2201/4813/files/player_blank.png?v=1673854814';
    }
    playerHtml += '<img src="'+img+'" alt="">';
  
  playerHtml += '</div>';
    
  if(data.description != null && data.description != '' && data.description != '\n'){
  playerHtml += '<div class="player-quotes">';
      playerHtml += '<div class="quote-icon">';
          playerHtml += '<svg xmlns="http://www.w3.org/2000/svg" width="87" height="86" viewBox="0 0 87 86">';
            playerHtml += '<g id="Group_1209" data-name="Group 1209" transform="translate(0.29 -0.232)">';
              playerHtml += '<g id="Ellipse_89" data-name="Ellipse 89" transform="translate(-0.29 0.232)" fill="#ae9357" stroke="#fff" stroke-width="3">';
                playerHtml += '<ellipse cx="43.5" cy="43" rx="43.5" ry="43" stroke="none"/>';
                playerHtml += '<ellipse cx="43.5" cy="43" rx="42" ry="41.5" fill="none"/>';
              playerHtml += '</g>';
              playerHtml += '<path id="Icon_awesome-quote-left" data-name="Icon awesome-quote-left" d="M35.1,19.2H29.049V14.354a4.846,4.846,0,0,1,4.842-4.842H34.5A1.811,1.811,0,0,0,36.312,7.7V4.066A1.811,1.811,0,0,0,34.5,2.25h-.605a12.1,12.1,0,0,0-12.1,12.1V32.51a3.632,3.632,0,0,0,3.631,3.631H35.1a3.632,3.632,0,0,0,3.631-3.631V22.827A3.632,3.632,0,0,0,35.1,19.2Zm-21.787,0H7.262V14.354A4.846,4.846,0,0,1,12.1,9.512h.605A1.811,1.811,0,0,0,14.525,7.7V4.066A1.811,1.811,0,0,0,12.709,2.25H12.1A12.1,12.1,0,0,0,0,14.354V32.51a3.632,3.632,0,0,0,3.631,3.631h9.683a3.632,3.632,0,0,0,3.631-3.631V22.827A3.632,3.632,0,0,0,13.314,19.2Z" transform="translate(23.207 23.879)" fill="#fff"/>';
            playerHtml += '</g>';
          playerHtml += '</svg>';
      playerHtml += '</div>';
      playerHtml += '<h4>'+data.description+'</h4>';
  playerHtml += '</div>';
  }

  if(data.isActive == 0){
    playerHtml += '<div class="player-inactive-wrapper">';
      playerHtml += '<div class="player-inactive-inner">';
        //playerHtml += '<h4>'+data.firstName+' '+data.lastName+' stand von '+data.activeFrom+' - '+data.activeUntil+' beim FC ZÜRICH unter '+data.position+'.</h4>';
        playerHtml += '<h4>'+data.firstName+' '+data.lastName+' stand von '+data.activeFrom+' - '+data.activeUntil+' beim FC ZÜRICH im Kader.</h4>';
      playerHtml += '</div>';
    playerHtml += '</div>';
  }
    
  
  $('.player-personal-details .player-details').html(html);
  $('.player-personal-details .player-image').html(playerHtml);

   $('#status').fadeOut();
   $('#preloader').fadeOut('slow');
  
  var playerNZ = '';
//   console.log(data.news.length);
  if(data.news.length > 0 ){
    for(var nz = 0; nz<data.news.length;nz++){
      var imagesrc = data.news[nz].optimizedImage;
      var title = jQuery.trim(data.news[nz].name);
      var description = jQuery.trim(data.news[nz].description).replace(/(<([^>]+)>)/ig,"");
      
      var url=data.news[nz].id;
      if(data.news[nz].urlHandle != null){
        url = data.news[nz].urlHandle;
      }

      if(data.news[nz].optimizedImage != null){
        imagesrc = data.news[nz].optimizedImage;
      }else if(data.news[nz].image != null ){
        imagesrc = data.news[nz].image;
      }else{
        imagesrc = 'https://cdn.shopify.com/s/files/1/0565/2201/4813/files/news-blank-image.png';
      }

      if(data.news[nz].excerpt != null && data.news[nz].excerpt != ""){
        description = data.news[nz].excerpt;
      }else {
        description = '';
      }

      var focusXPercentage = "";
      if(data.news[nz].focusXPercentage != null && data.news[nz].focusXPercentage != ''){
        focusXPercentage = data.news[nz].focusXPercentage+'%';
      }else {
        focusXPercentage = 'top';
      }

      var focusYPercentage = "";
      if(data.news[nz].focusYPercentage != null && data.news[nz].focusYPercentage != ''){
        focusYPercentage = data.news[nz].focusYPercentage+'%';
      }else {
        focusYPercentage = 'center';
      }

      /*
      if(data.news[nz].description > 150){
        description = jQuery.trim(data.news[nz].description).substring(0, 150).split(" ").slice(0, -2).join(" ").replace(/(<([^>]+)>)/ig, '') + "...";
        // description = description.slice(0, -5).toString().replace(/<[^>]*>/g, '');
      }
      if(title.length > 50){
        title = jQuery.trim(data.news[nz].name).substring(0, 50).split(" ").slice(0, -1).join(" ") + "...";
      }*/

      playerNZ += '<li class="multicolumn-list__item grid__item">';
      playerNZ += '<div class="multicolumn-card content-container">';
      playerNZ += '<div class="multicolumn-card__image-wrapper multicolumn-card__image-wrapper--full-width multicolumn-card-spacing">';
      playerNZ += '<div class="media media--transparent media--adapt" style="padding-bottom: 16.00338696020322%;">'
      playerNZ += '<img class="multicolumn-card__image" src="'+imagesrc+'" alt="" height="366" width="406" loading="lazy" style="object-position: '+focusXPercentage+' '+focusYPercentage+'">';
      playerNZ += '</div>';

      playerNZ += '<span class="badge">'+formatDateString(data.news[nz].publishDate,'','false')+'</span>';

      playerNZ += '</div>';
      playerNZ += '<div class="multicolumn-card__info"><h3>'+title+'</h3><div class="rte">'+description+'</div></div>';
      playerNZ += '<div class="link-wrapper">';
      playerNZ += '<a href="/pages/news/'+url+'" class="block-btn"><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 448 512"><path d="M256 64C256 46.33 270.3 32 288 32H415.1C415.1 32 415.1 32 415.1 32C420.3 32 424.5 32.86 428.2 34.43C431.1 35.98 435.5 38.27 438.6 41.3C438.6 41.35 438.6 41.4 438.7 41.44C444.9 47.66 447.1 55.78 448 63.9C448 63.94 448 63.97 448 64V192C448 209.7 433.7 224 416 224C398.3 224 384 209.7 384 192V141.3L214.6 310.6C202.1 323.1 181.9 323.1 169.4 310.6C156.9 298.1 156.9 277.9 169.4 265.4L338.7 96H288C270.3 96 256 81.67 256 64V64zM0 128C0 92.65 28.65 64 64 64H160C177.7 64 192 78.33 192 96C192 113.7 177.7 128 160 128H64V416H352V320C352 302.3 366.3 288 384 288C401.7 288 416 302.3 416 320V416C416 451.3 387.3 480 352 480H64C28.65 480 0 451.3 0 416V128z"></path></svg></a>';
      playerNZ += '</div>';
      playerNZ += '</div>';
      playerNZ += '</li>';
    }
  
 	$('.player-news ul.multicolumn-list').html(playerNZ);
    $('.player-news .button').attr('href','/pages/news?player='+PlayerID);
  }
  else{
  	$('.player-news').hide();
  }
  
  //if(playerID != ''){
  var matchHtml = '';
  var playerStatistic = data.playerStatistic;
  var flagp = 0;

      matchHtml += '<div class="player-professional-details-inner">';
      
       matchHtml += '<form method="GET" action="" id="season-form">';
          matchHtml += '<label for="id_season">'+season_t[lang]+':</label>';
          matchHtml += '<select name="season" id="id_season">';
            $.each( playerStatistic, function( key, value ) {
              if(value != null){
                flagp++;
                matchHtml += '<option value="'+key+'">'+key+'</option>';
              }
            });
          matchHtml += '</select>';
       matchHtml += '</form>';

      /*if(Beim_FCZ_seit == null){
        Beim_FCZ_seit = '-';
      }
      if(biggest_success == null){
        biggest_success = '-';
      }
      if(former_clubs == null){
        former_clubs = '-';
      }*/
      matchHtml += '<div class="player-with-fcz">';
          if(Beim_FCZ_seit != null && Beim_FCZ_seit != ''){
            matchHtml += '<div class="pl-since-fcz">';
                matchHtml += '<h3><span class="icon-span"><svg xmlns="http://www.w3.org/2000/svg" width="21.212" height="21.549" viewBox="0 0 21.212 21.549">';
                    matchHtml += '<path id="Icon_awesome-flag" data-name="Icon awesome-flag" d="M14.938,4.158c-2.255,0-4.118-1.464-6.954-1.464A8.18,8.18,0,0,0,5.121,3.2,2.357,2.357,0,1,0,1.573,4.291V20.539a1.01,1.01,0,0,0,1.01,1.01h.673a1.01,1.01,0,0,0,1.01-1.01V16.566a11.759,11.759,0,0,1,4.816-.931c2.255,0,4.118,1.464,6.954,1.464a8.811,8.811,0,0,0,5.156-1.72,1.344,1.344,0,0,0,.583-1.109V4.038A1.347,1.347,0,0,0,19.86,2.817a12.253,12.253,0,0,1-4.922,1.341Z" transform="translate(-0.563)" fill="#ae9357"/>';
                matchHtml += '</svg></span>';
                matchHtml += ''+at_fcz_t[lang]+'</h3>';
                matchHtml += '<span>'+Beim_FCZ_seit+'</span>';
            matchHtml += '</div>';
          }
          if(biggest_success != null && biggest_success != ''){
            matchHtml += '<div class="player-success">';
                matchHtml += '<h3> <span class="icon-span"><svg xmlns="http://www.w3.org/2000/svg" width="22.399" height="22.404" viewBox="0 0 22.399 22.404"><path id="Icon_ionic-md-trophy" data-name="Icon ionic-md-trophy" d="M21.9,6.444c.048-1.454.011-3.015.005-3.069H7.214c0,.054-.043,1.615.005,3.069H3.375c0,3.661.533,5.508,1.131,6.822a9.514,9.514,0,0,0,3.161,3.785,37.491,37.491,0,0,0,5.616,3.1v1.524c-.248.538-1.265,1.518-4.485,1.518H7.682v2.584H21.466V23.195H20.082c-3.268,0-4.038-1.028-4.216-1.518V20.152a60.121,60.121,0,0,0,5.621-3.1,11.111,11.111,0,0,0,3.161-3.785,19.128,19.128,0,0,0,1.125-6.827ZM6.692,12.2a8.876,8.876,0,0,1-.845-3.333H7.392c.038.323.075.608.124.878A23.847,23.847,0,0,0,8.9,14.94,7.723,7.723,0,0,1,6.692,12.2Zm15.765,0a7.778,7.778,0,0,1-2.24,2.762,23.514,23.514,0,0,0,1.389-5.217c.043-.269.086-.555.124-.878h1.578A8.877,8.877,0,0,1,22.457,12.2Z" transform="translate(-3.375 -3.375)" fill="#ae9357"/></svg></span>'+big_success_t[lang]+'</h3>';
                matchHtml += '<span>'+biggest_success+'</span>';
            matchHtml += '</div>';
          }          
          if(former_clubs != null && former_clubs != ''){
            matchHtml += '<div class="player-former-club">';
                matchHtml += '<h3><span class="icon-span"><svg xmlns="http://www.w3.org/2000/svg" width="24.47" height="24.47" viewBox="0 0 24.47 24.47"><path id="Icon_ionic-md-football" data-name="Icon ionic-md-football" d="M15.61,3.375A12.235,12.235,0,1,0,27.845,15.61,12.248,12.248,0,0,0,15.61,3.375ZM8.022,14.563l2.306,1.053,1.006,3.935-.918,1.723-3.365-.041A10.273,10.273,0,0,1,5.434,16.8ZM20.8,21.275l-.918-1.723,1.006-3.941,2.3-1.047L25.78,16.8a10.2,10.2,0,0,1-1.618,4.429Zm1.906-8.6-2.565,1.153-3.594-3.035V8.016L19.369,6.1a10.489,10.489,0,0,1,4.447,3.4ZM11.8,6.1,14.61,8.016v2.776l-3.588,3.029L8.493,12.669l-1.1-3.153A10.187,10.187,0,0,1,11.8,6.1ZM13.4,25.61c-.041-.012-.076-.018-.118-.029l-1.206-3.241.865-1.729h5.341l.882,1.782L18,25.563c-.059.012-.118.029-.176.041a14.83,14.83,0,0,1-2.376.241A9.974,9.974,0,0,1,13.4,25.61Z" transform="translate(-3.375 -3.375)" fill="#ae9357"/></svg></span>'+former_clubs_t[lang]+'</h3>';
                matchHtml += '<span>'+former_clubs+'</span>';
            matchHtml += '</div>';
          }
      matchHtml += '</div>';

      $.each( playerStatistic, function( key, playerAttribute ) {
        if(playerAttribute != null && key == season){
          match = playerAttribute.MatchesPlayedScouting;          
          matchHtml += '<div class="player-with-fcz-others">';
            matchHtml += '<div class="pl-matches">';
                matchHtml += '<svg id="football" xmlns="http://www.w3.org/2000/svg" width="25.767" height="18.909" viewBox="0 0 25.767 18.909">';
                    matchHtml += '<path id="Path_12107" data-name="Path 12107" d="M977.363,427.323c-1.535,0-3.071-.006-4.606.006-.272,0-.348-.079-.347-.349q.016-2.758,0-5.517a.361.361,0,0,1,.286-.4,3.39,3.39,0,0,0,0-6.377.362.362,0,0,1-.288-.4q.013-2.772,0-5.544c0-.241.069-.322.317-.321,3.071.007,6.142,0,9.213.008a2.557,2.557,0,0,1,2.512,2.518c.006.786-.006,1.571.006,2.357,0,.232-.067.309-.3.308-1.267-.01-2.535,0-3.8,0-.725,0-1.04.319-1.041,1.051q0,3.214,0,6.428c0,.742.317,1.056,1.066,1.056,1.249,0,2.5.006,3.749,0,.258,0,.339.076.334.334-.015.759,0,1.517-.006,2.276a2.558,2.558,0,0,1-2.565,2.575C980.38,427.327,978.871,427.323,977.363,427.323Z" transform="translate(-958.693 -408.419)" fill="#ae9357"/>';
                    matchHtml += '<path id="Path_12108" data-name="Path 12108" d="M787.48,408.415c1.545,0,3.089.006,4.634-.006.274,0,.347.084.344.35q-.016,2.758,0,5.517a.342.342,0,0,1-.263.389,3.367,3.367,0,0,0-.128,6.342.506.506,0,0,1,.394.572c-.016,1.785-.008,3.571-.008,5.357,0,.374,0,.375-.361.375q-4.527,0-9.053,0a2.562,2.562,0,0,1-2.625-2.624c0-.732,0-1.464,0-2.2,0-.358,0-.359.35-.36q1.875,0,3.75,0c.725,0,1.044-.321,1.044-1.051q0-3.214,0-6.428c0-.741-.318-1.055-1.067-1.055-1.25,0-2.5-.006-3.75.005-.259,0-.338-.078-.333-.334.015-.777,0-1.553.007-2.33a2.561,2.561,0,0,1,2.512-2.519c1.517-.008,3.035,0,4.553,0Z" transform="translate(-780.407 -408.409)" fill="#ae9357"/>';
                    matchHtml += '<path id="Path_12109" data-name="Path 12109" d="M780.442,507.025c0-.767.006-1.535,0-2.3,0-.219.066-.3.29-.294q1.446.014,2.891,0c.219,0,.294.068.293.29q-.011,2.3,0,4.6c0,.219-.066.3-.29.294q-1.446-.014-2.891,0c-.219,0-.3-.068-.293-.291C780.448,508.561,780.442,507.794,780.442,507.025Z" transform="translate(-780.436 -497.569)" fill="#ae9357"/>';
                    matchHtml += '<path id="Path_12110" data-name="Path 12110" d="M1095.882,507.022c0,.759-.009,1.517,0,2.275,0,.24-.08.3-.31.3-.954-.01-1.909-.011-2.865,0-.241,0-.3-.082-.3-.311q.012-2.289,0-4.578c0-.239.08-.3.31-.3.954.01,1.909.011,2.865,0,.241,0,.3.081.3.311C1095.875,505.488,1095.882,506.255,1095.882,507.022Z" transform="translate(-1070.12 -497.551)" fill="#ae9357"/>';
                    matchHtml += '<path id="Path_12111" data-name="Path 12111" d="M938.238,516.49a1.733,1.733,0,1,1-1.748,1.711A1.709,1.709,0,0,1,938.238,516.49Z" transform="translate(-925.339 -508.768)" fill="#ae9357"/>';
                matchHtml += '</svg>';
                matchHtml += '<h3>'+matches_t[lang]+'</h3>';
                matchHtml += '<span>'+match+'</span>';
            matchHtml += '</div>';
            matchHtml += '<div class="pl-game-minute">';
                matchHtml += '<svg id="_30-seconds-on-a-timer" data-name="30-seconds-on-a-timer" xmlns="http://www.w3.org/2000/svg" width="22.373" height="22.376" viewBox="0 0 22.373 22.376">';
                    matchHtml += '<path id="Path_12093" data-name="Path 12093" d="M837.85,428.078h-1.833c-.518-.07-1.037-.131-1.547-.247A11.191,11.191,0,1,1,839.409,406a10.9,10.9,0,0,1,8.3,7.87,11.669,11.669,0,0,1,.4,2.117v1.833a13.117,13.117,0,0,1-.249,1.546,11.093,11.093,0,0,1-7.892,8.316A11.718,11.718,0,0,1,837.85,428.078Zm-9.895-11.185a8.979,8.979,0,1,0,9-8.968A8.986,8.986,0,0,0,827.956,416.893Z" transform="translate(-825.734 -405.702)" fill="#ae9357"/>';
                    matchHtml += '<path id="Path_12094" data-name="Path 12094" d="M958.385,451.245v-7.7c0-.374,0-.382.36-.367a7.914,7.914,0,0,1,5.463,2.427,7.556,7.556,0,0,1,2.15,4.089,7.9,7.9,0,0,1-3.067,8.029,7.657,7.657,0,0,1-4.628,1.638c-.227.007-.283-.066-.283-.281Q958.391,455.162,958.385,451.245Zm6.938.156a3.526,3.526,0,0,0-.2-1.3,1.038,1.038,0,0,0-1.1-.713,1.006,1.006,0,0,0-1.111.7,3.678,3.678,0,0,0,.014,2.582,1.04,1.04,0,0,0,1.078.662,1.074,1.074,0,0,0,1.093-.643A3.429,3.429,0,0,0,965.323,451.4Zm-4.382-2a1.1,1.1,0,0,0-1.188.776c-.042.15-.065.289.111.371a.371.371,0,0,0,.464-.126c.043-.066.066-.145.106-.214a.512.512,0,0,1,.627-.216.5.5,0,0,1,.343.5.466.466,0,0,1-.352.488c-.177.054-.413.064-.4.318.01.235.237.24.408.287a.555.555,0,0,1,.436.653.582.582,0,0,1-.6.523.552.552,0,0,1-.56-.427.371.371,0,0,0-.486-.209c-.193.07-.212.228-.17.4a.937.937,0,0,0,.579.69,1.753,1.753,0,0,0,1.111.066,1.08,1.08,0,0,0,.818-.824,1,1,0,0,0-.3-1.11c-.119-.1-.134-.178-.022-.3a.947.947,0,0,0-.345-1.532A1.331,1.331,0,0,0,960.941,449.4Z" transform="translate(-947.37 -440.062)" fill="#ae9357"/>';
                    matchHtml += '<path id="Path_12095" data-name="Path 12095" d="M872.872,531.32c-.349,0-.7,0-1.046,0-.16,0-.241-.045-.237-.222.008-.472.006-.945,0-1.417,0-.156.055-.223.215-.222q1.068.006,2.136,0c.16,0,.217.066.216.222-.006.472-.007.945,0,1.417,0,.177-.077.226-.237.223C873.569,531.316,873.221,531.32,872.872,531.32Z" transform="translate(-867.783 -519.188)" fill="#ae9357"/>';
                    matchHtml += '<path id="Path_12096" data-name="Path 12096" d="M919.351,608.3a2.828,2.828,0,0,1-.544-.328c-.051-.044-.007-.11.021-.159.273-.471.548-.94.82-1.411.054-.093.12-.12.213-.057a.272.272,0,0,0,.038.021c.5.271.5.271.221.76q-.3.518-.6,1.034C919.483,608.217,919.458,608.294,919.351,608.3Z" transform="translate(-911.06 -589.658)" fill="#ae9357"/>';
                    matchHtml += '<path id="Path_12097" data-name="Path 12097" d="M920.545,452.7c0,.077-.052.1-.092.129-.5.356-.5.356-.817-.18-.2-.338-.39-.679-.593-1.013-.082-.135-.066-.217.076-.295.586-.325.432-.352.755.185.206.341.4.688.6,1.033C920.5,452.611,920.526,452.663,920.545,452.7Z" transform="translate(-911.252 -447.341)" fill="#ae9357"/>';
                    matchHtml += '<path id="Path_12098" data-name="Path 12098" d="M884.014,486.3c.025.012.066.029.1.051.447.257.89.519,1.339.77.139.078.164.156.08.294-.359.589-.2.514-.747.213-.355-.2-.7-.408-1.057-.607-.128-.072-.161-.149-.076-.277s.139-.238.209-.356C883.9,486.335,883.925,486.28,884.014,486.3Z" transform="translate(-878.806 -479.604)" fill="#ae9357"/>';
                    matchHtml += '<path id="Path_12099" data-name="Path 12099" d="M884.092,577.953c-.083,0-.105-.047-.135-.086-.36-.482-.355-.507.162-.808.351-.2.7-.4,1.053-.611.116-.069.193-.065.263.062.344.619.369.451-.189.785-.33.2-.664.386-1,.578C884.192,577.906,884.133,577.933,884.092,577.953Z" transform="translate(-878.893 -562.236)" fill="#ae9357"/>';
                    matchHtml += '<path id="Path_12100" data-name="Path 12100" d="M1020.267,526.356a4.758,4.758,0,0,1-.1.964c-.078.278-.22.413-.457.421a.469.469,0,0,1-.494-.4,4.8,4.8,0,0,1-.028-1.924.55.55,0,0,1,.242-.4.485.485,0,0,1,.728.3A4.316,4.316,0,0,1,1020.267,526.356Z" transform="translate(-1003.056 -515.042)" fill="#ae9357"/>';
                matchHtml += '</svg>';
                matchHtml += '<h3>'+minutes_played_t[lang]+'</h3>';
    //           		let playTime = playerAttribute.PlayingTime.split(':');
                
    //           		matchHtml += '<span>'+ playTime[0]+'h '+playTime[1]+'min '+playTime[2] +'sek</span>';
                    matchHtml += '<span>'+ playerAttribute.NormalizedPlayerMinutes +'</span>';
          
            matchHtml += '</div>';
            matchHtml += '<div class="pl-tore">';
                matchHtml += '<svg xmlns="http://www.w3.org/2000/svg" width="19" height="19" viewBox="0 0 19 19">';
                    matchHtml += '<g id="Group_1036" data-name="Group 1036" transform="translate(0 -1736.046)">';
                    matchHtml += '<circle id="Ellipse_88" data-name="Ellipse 88" cx="9.5" cy="9.5" r="9.5" transform="translate(0 1736.046)" fill="#ae9357"/>';
                    matchHtml += '<g id="Group_971" data-name="Group 971" transform="translate(3.189 1739.555)">';
                        matchHtml += '<rect id="Rectangle_635" data-name="Rectangle 635" width="12.2" height="3.838" transform="translate(0.283 3.959)" fill="#fff" style="mix-blend-mode: normal;isolation: isolate"/>';
                        matchHtml += '<rect id="Rectangle_636" data-name="Rectangle 636" width="0.566" height="4.323" transform="translate(0 3.717)" fill="#fff" style="mix-blend-mode: normal;isolation: isolate"/>';
                        matchHtml += '<rect id="Rectangle_637" data-name="Rectangle 637" width="0.566" height="4.323" transform="translate(12.2 3.717)" fill="#fff" style="mix-blend-mode: normal;isolation: isolate"/>';
                        matchHtml += '<rect id="Rectangle_638" data-name="Rectangle 638" width="11.19" height="4.939" transform="translate(8.711 0.283) rotate(90)" fill="#fff" style="mix-blend-mode: normal;isolation: isolate"/>';
                        matchHtml += '<rect id="Rectangle_639" data-name="Rectangle 639" width="0.566" height="5.373" transform="translate(8.928 11.19) rotate(90)" fill="#fff" style="mix-blend-mode: normal;isolation: isolate"/>';
                        matchHtml += '<rect id="Rectangle_640" data-name="Rectangle 640" width="0.566" height="5.373" transform="translate(8.928 0) rotate(90)" fill="#fff" style="mix-blend-mode: normal;isolation: isolate"/>';
                        matchHtml += '<circle id="Ellipse_87" data-name="Ellipse 87" cx="2.01" cy="2.01" r="2.01" transform="translate(4.232 3.868)" fill="#ae9357" style="mix-blend-mode: normal;isolation: isolate"/>';
                    matchHtml += '</g>';
                    matchHtml += '</g>';
                matchHtml += '</svg>';
                matchHtml += '<h3>'+goals_t[lang]+'</h3>';
                matchHtml += '<span>'+playerAttribute.ShotsAtGoalSuccessfull+'</span>';
            matchHtml += '</div>';
            matchHtml += '<div class="pl-tore">';
                matchHtml += '<svg xmlns="http://www.w3.org/2000/svg" width="19" height="19" viewBox="0 0 19 19">';
                    matchHtml += '<g id="Group_1036" data-name="Group 1036" transform="translate(0 -1736.046)">';
                    matchHtml += '<circle id="Ellipse_88" data-name="Ellipse 88" cx="9.5" cy="9.5" r="9.5" transform="translate(0 1736.046)" fill="#ae9357"/>';
                    matchHtml += '<g id="Group_971" data-name="Group 971" transform="translate(3.189 1739.555)">';
                        matchHtml += '<rect id="Rectangle_635" data-name="Rectangle 635" width="12.2" height="3.838" transform="translate(0.283 3.959)" fill="#fff" style="mix-blend-mode: normal;isolation: isolate"/>';
                        matchHtml += '<rect id="Rectangle_636" data-name="Rectangle 636" width="0.566" height="4.323" transform="translate(0 3.717)" fill="#fff" style="mix-blend-mode: normal;isolation: isolate"/>';
                        matchHtml += '<rect id="Rectangle_637" data-name="Rectangle 637" width="0.566" height="4.323" transform="translate(12.2 3.717)" fill="#fff" style="mix-blend-mode: normal;isolation: isolate"/>';
                        matchHtml += '<rect id="Rectangle_638" data-name="Rectangle 638" width="11.19" height="4.939" transform="translate(8.711 0.283) rotate(90)" fill="#fff" style="mix-blend-mode: normal;isolation: isolate"/>';
                        matchHtml += '<rect id="Rectangle_639" data-name="Rectangle 639" width="0.566" height="5.373" transform="translate(8.928 11.19) rotate(90)" fill="#fff" style="mix-blend-mode: normal;isolation: isolate"/>';
                        matchHtml += '<rect id="Rectangle_640" data-name="Rectangle 640" width="0.566" height="5.373" transform="translate(8.928 0) rotate(90)" fill="#fff" style="mix-blend-mode: normal;isolation: isolate"/>';
                        matchHtml += '<circle id="Ellipse_87" data-name="Ellipse 87" cx="2.01" cy="2.01" r="2.01" transform="translate(4.232 3.868)" fill="#ae9357" style="mix-blend-mode: normal;isolation: isolate"/>';
                    matchHtml += '</g>';
                    matchHtml += '</g>';
                matchHtml += '</svg>';
                matchHtml += '<h3>'+assists_t[lang]+'</h3>';
                matchHtml += '<span>'+playerAttribute.Assists+'</span>';
            matchHtml += '</div>';
            /*matchHtml += '<div class="pl-shot-tgt">';
                matchHtml += '<svg id="football-ball" xmlns="http://www.w3.org/2000/svg" width="26.146" height="20.008" viewBox="0 0 26.146 20.008">';
                    matchHtml += '<path id="Path_12101" data-name="Path 12101" d="M1013.822,674.1l-5.072.006q-2.485,0-4.971,0a.587.587,0,0,1-.3-.029c-.032-.084.038-.107.084-.134a11.626,11.626,0,0,0,1.759-1.3.488.488,0,0,1,.343-.137q4.015,0,8.029,0a1.218,1.218,0,0,1,.127.012Z" transform="translate(-987.676 -654.1)" fill="#ae9357"/>';
                    matchHtml += '<path id="Path_12102" data-name="Path 12102" d="M1078.119,457.915c-.51.005-1.02.015-1.529.015-1.173,0-2.347,0-3.521,0a.331.331,0,0,1-.377-.251,8.428,8.428,0,0,0-.465-1.076c-.118-.236-.094-.274.178-.275.867,0,1.735,0,2.6,0h3.112Q1078.119,457.124,1078.119,457.915Z" transform="translate(-1051.973 -451.748)" fill="#ae9357"/>';
                    matchHtml += '<path id="Path_12103" data-name="Path 12103" d="M1078.121,602.209h-5.638c-.371,0-.385-.02-.221-.345a10.338,10.338,0,0,0,.453-1.053c.045-.121.1-.2.254-.2q2.564.01,5.127.012a.112.112,0,0,1,.025.005Q1078.122,601.418,1078.121,602.209Z" transform="translate(-1051.975 -586.805)" fill="#ae9357"/>';
                    matchHtml += '<path id="Path_12104" data-name="Path 12104" d="M1096.423,530.228c-.4.006-.8.017-1.2.018-1.069,0-2.139,0-3.209.005-.233,0-.316-.07-.3-.3.017-.347,0-.7,0-1.044,0-.121.018-.222.174-.222,1.51.007,3.021-.026,4.531.017Z" transform="translate(-1070.278 -519.468)" fill="#ae9357"/>';
                    matchHtml += '<path id="Path_12105" data-name="Path 12105" d="M756.32,394.611a9.989,9.989,0,1,1,9.991,10A9.975,9.975,0,0,1,756.32,394.611Zm14.717,5.758c.4,0,.8,0,1.2,0a.4.4,0,0,0,.332-.148,8.6,8.6,0,0,0,1.718-2.957.477.477,0,0,0-.045-.433c-.389-.659-.764-1.326-1.156-1.984a.4.4,0,0,1,0-.467c.388-.65.757-1.31,1.143-1.961a.521.521,0,0,0,.052-.479,8.666,8.666,0,0,0-1.71-2.934.429.429,0,0,0-.357-.15c-.774,0-1.548,0-2.321.005a.387.387,0,0,1-.387-.222c-.375-.667-.764-1.326-1.14-1.993a.505.505,0,0,0-.368-.275,8.667,8.667,0,0,0-3.368,0,.5.5,0,0,0-.373.268c-.374.667-.767,1.324-1.141,1.992a.406.406,0,0,1-.409.23c-.757-.008-1.514,0-2.271-.006a.5.5,0,0,0-.421.183,8.694,8.694,0,0,0-1.671,2.87.58.58,0,0,0,.055.53c.385.651.754,1.312,1.139,1.963a.361.361,0,0,1,0,.42c-.385.651-.755,1.312-1.14,1.963a.582.582,0,0,0-.057.53,8.683,8.683,0,0,0,1.67,2.87.5.5,0,0,0,.42.186c.757-.008,1.514,0,2.271-.007a.423.423,0,0,1,.423.25c.362.646.745,1.278,1.1,1.926a.587.587,0,0,0,.447.325,8.807,8.807,0,0,0,3.268,0,.591.591,0,0,0,.445-.328c.364-.654.747-1.3,1.114-1.949a.382.382,0,0,1,.385-.224C770.272,400.378,770.655,400.369,771.037,400.369Z" transform="translate(-756.32 -384.62)" fill="#ae9357"/>';
                    matchHtml += '<path id="Path_12106" data-name="Path 12106" d="M861.01,498.54c-.51,0-1.02,0-1.53,0a.394.394,0,0,1-.388-.224q-.761-1.341-1.542-2.672a.363.363,0,0,1-.007-.419q.788-1.34,1.555-2.693a.377.377,0,0,1,.368-.213q1.542,0,3.085,0a.359.359,0,0,1,.349.2q.777,1.361,1.568,2.715a.332.332,0,0,1,.007.376q-.8,1.364-1.581,2.737a.358.358,0,0,1-.355.191C862.029,498.538,861.52,498.54,861.01,498.54Z" transform="translate(-851.014 -485.436)" fill="#ae9357"/>';
                matchHtml += '</svg>';
                matchHtml += '<h3>SCHÜSSE AUFS TOR</h3>';
                matchHtml += '<span>'+ playerAttribute.ShotsAtGoalSum +'</span>';
            matchHtml += '</div>';*/
            
            matchHtml += '<div class="pl-substitutions">';
                matchHtml += '<svg id="shuffle" xmlns="http://www.w3.org/2000/svg" width="21.589" height="18.909" viewBox="0 0 21.589 18.909">';
                    matchHtml += '<path id="Path_12112" data-name="Path 12112" d="M777.816,425.059a1.14,1.14,0,0,1-.325.407q-1.944,1.614-3.882,3.236a.71.71,0,0,1-.8.14.691.691,0,0,1-.4-.7c.006-.569,0-1.138,0-1.706,0-.178-.059-.226-.231-.226a9.157,9.157,0,0,1-2.013-.105,5.368,5.368,0,0,1-3.492-2.473q-2.085-3.328-4.161-6.662a2.947,2.947,0,0,0-1.677-1.417,3.454,3.454,0,0,0-.956-.121q-1.7-.008-3.391,0c-.2,0-.266-.057-.263-.261q.016-1.116,0-2.232c0-.186.059-.241.242-.24,1.3.007,2.6-.041,3.9.017a5.043,5.043,0,0,1,4.154,2.33c1.053,1.583,2.031,3.216,3.041,4.828.47.749.943,1.5,1.406,2.25a2.748,2.748,0,0,0,2.5,1.363c.238,0,.478-.008.716,0,.172.008.234-.047.231-.225-.01-.561,0-1.123-.005-1.685a.7.7,0,0,1,.4-.724.725.725,0,0,1,.818.154q1.932,1.612,3.865,3.222a1.151,1.151,0,0,1,.324.407Z" transform="translate(-756.228 -410.002)" fill="#ae9357"/>';
                    matchHtml += '<path id="Path_12113" data-name="Path 12113" d="M962.165,366.078a1.141,1.141,0,0,1-.325.407q-1.936,1.608-3.866,3.222a.724.724,0,0,1-.818.155.706.706,0,0,1-.4-.725c.007-.555-.006-1.11.006-1.664,0-.2-.066-.25-.254-.245a5.611,5.611,0,0,0-1.751.167,2.469,2.469,0,0,0-1.26.942c-.329.481-.629.981-.94,1.473-.134.212-.145.214-.272.012q-.687-1.1-1.373-2.2a.272.272,0,0,1-.023-.326,5.427,5.427,0,0,1,3.856-2.729,9.49,9.49,0,0,1,1.744-.06c.209,0,.281-.051.275-.27-.015-.554,0-1.109-.006-1.664a.692.692,0,0,1,.4-.7.711.711,0,0,1,.8.14q1.675,1.394,3.348,2.791c.216.18.432.359.646.541a.957.957,0,0,1,.213.311Q962.165,365.867,962.165,366.078Z" transform="translate(-940.577 -361.805)" fill="#ae9357"/>';
                    matchHtml += '<path id="Path_12114" data-name="Path 12114" d="M758.491,571.119c-.667,0-1.334,0-2,0-.172,0-.232-.054-.231-.229q.011-1.137,0-2.275c0-.175.057-.229.231-.228q1.717.009,3.433,0a2.891,2.891,0,0,0,1.641-.444,2.973,2.973,0,0,0,.874-.926c.256-.411.515-.82.767-1.234.082-.135.14-.182.243-.014q.7,1.129,1.4,2.251a.245.245,0,0,1,.013.289,5.426,5.426,0,0,1-3.892,2.744,3.652,3.652,0,0,1-.648.062c-.61,0-1.221,0-1.832,0A0,0,0,0,0,758.491,571.119Z" transform="translate(-756.258 -554.909)" fill="#ae9357"/>';
                matchHtml += '</svg>';
                matchHtml += '<h3>'+substitutions_t[lang]+'</h3>';
                matchHtml += '<span>' + playerAttribute.SubstitutionsIn + '</span>';
            matchHtml += '</div>';
            
            matchHtml += '<div class="pl-red-crd">';
                matchHtml += '<svg xmlns="http://www.w3.org/2000/svg" width="14" height="22" viewBox="0 0 14 22">';
                    matchHtml += '<rect id="Rectangle_642" data-name="Rectangle 642" width="14" height="22" rx="2" fill="#e40e0e"/>';
                matchHtml += '</svg>';
                matchHtml += '<h3>'+red_card_t[lang]+'</h3>';
                matchHtml += '<span>'+playerAttribute.CardsRed+'</span>';
            matchHtml += '</div>';
            matchHtml += '<div class="pl-yel-red-crd">';
                matchHtml += '<svg xmlns="http://www.w3.org/2000/svg" width="14.824" height="22.672" viewBox="0 0 14.824 22.672">';
                    matchHtml += '<g id="Group_1037" data-name="Group 1037" transform="translate(-0.455 0.823)">';
                    matchHtml += '<rect id="Rectangle_631" data-name="Rectangle 631" width="11.336" height="19.184" rx="2" transform="translate(0.455 -0.823)" fill="#e40e0e"/>';
                    matchHtml += '<rect id="Rectangle_632" data-name="Rectangle 632" width="12.208" height="17.44" rx="2" transform="translate(3.071 4.409)" fill="#ffd444"/>';
                    matchHtml += '</g>';
                matchHtml += '</svg>';
                matchHtml += '<h3>'+yellow_red_card_t[lang]+'</h3>';
                matchHtml += '<span>'+playerAttribute.CardsYellowRed+'</span>';
            matchHtml += '</div>';
            matchHtml += '<div class="pl-yellow-crd">';
                matchHtml += '<svg xmlns="http://www.w3.org/2000/svg" width="14" height="22" viewBox="0 0 14 22">';
                    matchHtml += '<rect id="Rectangle_641" data-name="Rectangle 641" width="14" height="22" rx="2" fill="#ffd444"/>';
                matchHtml += '</svg>';
                matchHtml += '<h3>'+yellow_card_t[lang]+'</h3>';
                matchHtml += '<span>'+playerAttribute.CardsYellow+'</span>';
            matchHtml += '</div>';
        matchHtml += '</div>';
      }
     });
     matchHtml += '</div>';

    $('.player-professional-details #player-professional-details').html(matchHtml);
    if(data.isActive == 0){
      $('.player-personal-details .multicolumn-list').addClass('player-inActive');
    }else{
      $('.player-personal-details .multicolumn-list').addClass('player-active');
    }

    $('.player-professional-details-inner #id_season option').attr("selected",false);
    $('.player-professional-details-inner #id_season option').each(function(){
      if(season == $(this).attr("value")){
        $('.player-professional-details-inner #id_season option[value="'+season+'"').attr("selected",true);
      }
    });
    if(flagp == 0){
      $('.player-professional-details-inner #season-form').remove();
    }

    $(document).on('error','.player-news .multicolumn-card__image',function(){
      $(this).attr('src','https://cdn.shopify.com/s/files/1/0565/2201/4813/files/news-blank-image.png')
    });
  });
}

$(document).on('change','.player-professional-details-inner #id_season', function(){
  $(this).closest('form').submit();
});
$(window).on('load',function(){
  $(document).on('error','.player-news .multicolumn-card__image',function(){
    $(this).attr('src','https://cdn.shopify.com/s/files/1/0565/2201/4813/files/news-blank-image.png')
  });
});